/**
 * @package  	Cavalree
 * @copyright	Copyright (c) 2025 Infantree (https://infantree.com/)
 * @version  	1.0.0
 *
 */

if (typeof $ === "undefined") {
  var $ = jQuery;
}

/*****************************
 * Vanilla JS functions
 *****************************/
document.addEventListener("DOMContentLoaded", function () {
  const filters = document.querySelectorAll(".resourceFilter");

  filters.forEach(function (filter) {
    if (filter) {
      let filterTxt = filter.innerHTML;

      filter.addEventListener("click", (e) => {
        console.log(e);
        document
          .querySelector(".blog__header--filter-bar")
          .classList.toggle("is-active");

        if (
          document
            .querySelector(".blog__header--filter-bar")
            .classList.contains("is-active")
        ) {
          filter.innerHTML = 'close filters <i class="icon-close"></i>';
        } else {
          filter.innerHTML = filterTxt;
        }
      });
    }
  });
});
// END Vanilla JS

/*****************************
 * jQuery Ready
 *****************************/
$(document).ready(function () {
  Fancybox.bind("[data-fancybox]");
});
